module.exports = __webpack_public_path__ + "static/media/home.e8dd3cd1.png";